// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"d54018bfff3b504a1ef0","966":"ddffc6c1ac3e14c97825"}[chunkId] + ".js";
};